// extracted by mini-css-extract-plugin
export default {"parent":"parent___C7tjv","child":"child___PSXHa","fadeOut":"fadeOut___Ay3gj","fadeInAndSlideUp":"fadeInAndSlideUp___mb2nI"};